import { API_ROOT, uniquenessCheck, sendRequest } from '../../supplementary_components/requests';
import { isValidPhoneNumber, phoneNumberTyping } from "../../supplementary_components/supplementaryMethods";

let cachedRoles = [];

export const getCachedOrgRoles = () => cachedRoles;

export const prefetchOrgRoles = () => {
    sendRequest('GET', API_ROOT + 'roles', null, (data) => {
        cachedRoles = Array.isArray(data) ? data : [];
    });
};

export const EMPLOYEE_ADD_CONF = {
    formAccessLevel: { key: 'USERS', level: 'MANAGE' },
    formTitle: "Add Employee",
    name: 'addEmployeeForm',
    addLink: API_ROOT+'employees/add',
    successMessage:'Employee was added',
    columns: [
        {
            label: "First name",
            autoComplete: "off",
            name: "firstName",
            mandatory: true,
            placeholder: "First name",
            checks : [
                (value) => {
                    if (!/^[a-zA-Z']+$/.test(value)) {
                        return "First name must contain only letters, without empty spaces or special characters.";
                    }
                    return null;
                },
            ],
        },
        {
            label: "Last name",
            autoComplete: "off",
            name: "lastName",
            mandatory: true,
            placeholder: "Last name",
            checks : [
                (value) => {
                    if (!/^[a-zA-Z]+$/.test(value)) {
                        return "Last name must contain only letters, without empty spaces or special characters.";
                    }
                    return null;
                },
            ],
        },
        {
            label: "Telegram Username",
            autoComplete: "off",
            name: "telegramUserName",
            placeholder: "@TelegramUser",
            checks : [
            (value) => {
                if (!/^@/.test(value)) {
                        return "Telegram username must start with the '@' special character.";
                    }
                    return null;
                }

            ],
        },
        {
            label: "Login",
            name: "login",
            mandatory: true,
            placeholder: "Minimum 5 characters no special symbols !@#$%^&*()_-+={}[]|;:'\"<>,./",
            checks : [
                (value) => {
                    return value.length < 5 ? 'User login name must be at least 5 characters' : null;
                }
                ,
                (value) => {
                    if (!/^[a-zA-Z0-9]+$/.test(value)) {
                        return "Login name must contain only letters and numbers not special characters !@#$%^&*()_-+={}[]|;:'\"<>,./";
                    }
                    return null;
                }
                ,
                (value) => {
                    if ( /\s/.test(value) || /^\s|\s$/.test(value)) {
                        return 'User login name cannot contain empty spaces, and no spaces before or after characters';
                    }
                    return null;
                }
                ,
                async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"employees/exists", "login", value, "Employee with this login already exists"));
                }),
            ],
        },
        {
           label: "Email",
           name: "email",
           mandatory: true,
           placeholder: "yourmailaddress@email.com",
           checks : [
              (value) => {
                  return value.length < 5 ? 'User login name must be at least 7 characters' : null;
              }
              ,
              (value) => {
                    if (!/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.(co|com|us|io|org|net|edu|gov|mil|ru)$/i.test(value)) {
                        return "Please enter a valid email address with a standard domain suffix (.com, .io, .org, etc.)";
                    }
                  return null;
              }
              ,
              (value) => {
                  if ( /\s/.test(value) || /^\s|\s$/.test(value)) {
                      return 'User login name cannot contain empty spaces, and no spaces before or after characters';
                  }
                  return null;
              }
              ,
              async (value, column) => new Promise(resolve => {
                    if(column.defaultValue){
                        if(column.defaultValue() === value){
                            resolve(null);
                            return;
                        }
                    }
                    resolve(uniquenessCheck(API_ROOT+"employees/exists", "email", value, "Employee with this email already exists"));
              }),
           ],
        },
        {
            label: "Role",
            name: "role",
            type: "select",
            mandatory: true,
            dataset: () => getCachedOrgRoles().map((role) => ({
                id: role.id,
                name: role.name,
                value: String(role.id),
                label: role.name,
            })),
            processBeforeSending: (val) => {
                const id = parseInt(val, 10);
                return Number.isFinite(id) ? { id } : null;
            },
        },
        {
            label: "Empoyee Of",
            name: "accessibleCompanies",
            type: "selectionList",
            nullAllowed:false,
            mandatory: true,
        },
        {
            label: "Direct line",
            placeholder: "(Optional) Phone Number 000-000-0000",
            autoComplete: "off",
            name: "directLine",
            mandatory: false,
            filters:[
                phoneNumberTyping
            ],
            onblur:(val, tar)=>{
                return isValidPhoneNumber(val, tar);
            },
        },
        {
            label: "Extension",
            placeholder: "(Optional) Ext.",
            autoComplete: "off",
            name: "extension",
            mandatory: false,
            checks : [
                (value) => {
                    if (!/^[0-9 -]+$/.test(value)) {
                        return "Extension must contain only numbers or '-' special character";
                    }
                    return null;
                }
            ],
        },
    ]
}
